import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { useStore } from '@modules';
import { VerificationStatusesEnum } from '@modules/user/types';

import style from './UserStatus.scss';

const cn = bemCssModules(style, 'UserStatus');

const { under_review, complete } = VerificationStatusesEnum;

const UserStatus: CustomFC = ({ className }) => {
  const { t } = useTranslation();
  const [{ user }] = useStore();
  const status = user.data?.checks.document;
  const checkEnabled = user.data?.checks.document_details.check_enabled;

  const displayStatus = () => {
    if (!checkEnabled) return t('settings.kyc_failed');
    const isSuccessStatus = status === complete || status === under_review;
    if (isSuccessStatus) return t(`settings.kyc_${status}`);
    return t('settings.kyc_incomplete');
  };

  return (
    <div className={cn(null, [className])}>
      <span className={cn('text')}>{t('profile.personal_data')}</span>
      <span className={cn('dot')}>{` · `}</span>
      <span className={cn('status', { status })}>{displayStatus()}</span>
    </div>
  );
};

export default UserStatus;
